<template>
  <div class="vuse-content-wrapper">
    <vuse-section-definition
      :title="page"
      :breadcrumbs="breadcrumbs"
      icon="mdi-format-list-checkbox"
    ></vuse-section-definition>

    <v-row class="fill-width">
      <v-col cols="8" sm="8"> </v-col>
      <v-col cols="4" sm="4" align="right">
        <v-btn color="primary" align="right" @click="addNew" v-if="hasPermissions('Create rule')"> Thêm </v-btn>
      </v-col>
    </v-row>

    <v-container fluid>
      <v-row justify="center" align="center">
        <v-col cols="12">
          <v-data-table
            :headers="headers"
            :items="rules"
            :items-per-page="10"
            class="elevation-1"
          >
            <template v-slot:item.is_active="{ item }">
              <v-switch
                  v-model="item.is_active"
                  @change="checkActive(item)"
              ></v-switch>
<!--              <v-card-text v-if="item.is_active == 0"-->
<!--                ><v-icon>mdi-square-outline</v-icon></v-card-text-->
<!--              >-->
<!--              <v-card-text v-else-if="item.is_active == 1"-->
<!--                ><v-icon>mdi-square-circle</v-icon></v-card-text-->
<!--              >-->
<!--              <span v-else>No</span>-->
            </template>
            <template v-slot:item.rule_type="{ item }">
              <span v-if="item.rule_type === 1"
                >Khuyến mại dựa trên số lượng sản phẩm</span
              >
              <span v-else-if="item.rule_type === 2"
                >Khuyến mại dựa trên giá sản phẩm</span
              >
              <span v-else-if="item.rule_type === 4"
                >Khuyến mại dựa trên số lượng sản phẩm theo dòng sản phẩm</span
              >
              <span v-else
                >Khuyến mại theo giảm giá hàng tháng theo danh muc</span
              >
            </template>
            <template v-slot:item.rule_property.brand_id="{ item }">
              <span v-if="item.rule_property.brand_id === 1">Thế giới bếp</span>
              <span v-else-if="item.rule_property.brand_id === 2">BOSCH</span>
              <span v-else-if="item.rule_property.brand_id === 3">WMF</span>
              <span v-else-if="item.rule_property.brand_id === 4">BLANCO</span>
              <span v-else-if="item.rule_property.brand_id === 5">BLUM</span>
              <span v-else-if="item.rule_property.brand_id === 6">FINISH</span>
              <span v-else> </span>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-icon small class="mr-2" @click="editItem(item)" v-if="hasPermissions('Update rule')">
                mdi-pencil
              </v-icon>
              <!--              <v-icon small class="mr-2" @click="reviewItem(item.id)">-->
              <!--                mdi-eye-->
              <!--              </v-icon>-->
              <v-icon small @click="deleteItem(item.id)" v-if="hasPermissions('Delete rule')"> mdi-delete </v-icon>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import { GET_LIST_RULES, DELETE_RULES,GET_DETAIL_RULES, UPDATE_RULES } from "@/store/modules/promotion_gift";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      check:false,
      page: "Khuyến mại",
      breadcrumbs: [
        {
          text: "Trang chủ",
          disabled: true,
        },
        {
          text: "Khuyến mại/Quà tặng",
          disabled: true,
        },
        {
          text: "Khuyến mại",
          disabled: true,
        },
      ],

      headers: [
        { text: "ID", value: "id" },
        { text: "Tên", value: "name" },
        { text: "Tên rule", value: "rule_type" },
        { text: "Nhãn hàng", value: "rule_property.brand_id" },
        { text: "Độ ưu tiên", value: "priority" },
        { text: "Hiển thị", value: "is_active" },
        { text: "Actions", value: "actions" },
      ],
      url: "",
    };
  },
  computed: {
    ...mapGetters({
      rules: "rules",
      ruleDetail: "ruleDetail",
    }),
  },

  watch: {
    ruleDetail(val) {
      console.log(val)
    }
  },

  async created() {
    await this.$store.dispatch(GET_LIST_RULES);
  },
  methods: {
    formatDate(input) {
      var datePart = input.match(/\d+/g),
          year = datePart[0],
          month = datePart[1],
          day = datePart[2];
      return day + "/" + month + "/" + year;
    },
    checkActive(item) {
      this.$store.dispatch(`${GET_DETAIL_RULES}`, item.id).then((data)=>{
        if(data) {
          let rules_form = {
            id: item.id,
            name: data.data.name,
            rule_type: data.data.rule_type,
            rule_property: JSON.stringify(data.data.rule_property),
            priority: parseInt(data.data.priority),
            start_date: data.data.start_date,
            end_date: data.data.end_date,
            is_active: item.is_active,
          };
          this.$store.dispatch(`${UPDATE_RULES}`, rules_form).then((data) => {
            if (data.data.status == 1) {
              this.$toasted.success('Cập nhật thành công!', {
                duration:1000,
                position:'top-center'
              })
            } else {
              alert(data.data.errors);
            }
          });
        }
      });
    },
    editItem(item) {
      this.$router.push(
        "/manage_promotion_gift/Manage_promotion/edit_promotion/" + item.id
      );
    },
    deleteItem(id) {
      confirm("Bạn có chắc muốn xóa?") &&
        this.$store.dispatch(`${DELETE_RULES}`, id).then((data) => {
          if (data && data.status === 1) {
            this.$store.dispatch(GET_LIST_RULES);
          }
        });
    },
    addNew() {
      this.$router.push(
        "/manage_promotion_gift/Manage_promotion/add_promotion"
      );
    },
  },
};
</script>
<style lang="scss">
.content_category1 {
  background: #ffffff !important;
}
.img-brand {
  max-width: 100px;
  max-height: 100px;
  margin: auto;
  display: block;
}
</style>
